export default __webpack_public_path__ + "static/media/13t.5bc564d5.jpg";